import { ProductType } from '../../types/product'

export type SortingParams = {
  field: 'price' | 'capacity'
  order: 'asc' | 'desc'
}

export const PlpSortStrategy = {
  Standard: 'standard',
  Manual: 'manual',
} as const

export type PlpSortStrategy = (typeof PlpSortStrategy)[keyof typeof PlpSortStrategy]

export type GetSanityProductParams = {
  instantBook: boolean
  capacity: string | undefined
  type: ProductType | ProductType[]
  buildings?: string[] | null
  sortingParams: SortingParams
  lastField: string | number | null
  lastId: string | null
  lastInquiryOnly: boolean | null
  lastPlpRank?: number | null
  paginated?: boolean
  sortStrategy?: PlpSortStrategy
}

export type GetCountSanityProductParams = {
  instantBook: boolean
  capacity: string | undefined
  type: ProductType | ProductType[]
  buildings?: string[] | null
}

export type BffErrorResponse = {
  statusCode: number
  timestamp: string
  path: string
  message: string
  context: ErrorContext
}

type ErrorContext = {
  workflow: string
  step: string
  action: string
  metadata: ErrorMetadata
}

type ErrorMetadata = {
  email?: string
  [key: string]: any
}
